import React from 'react';
import { StarIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { CART_URL } from '../utils/constants';
import { trackAddToCart } from '../utils/metaPixel';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/8cQ5rhfuBTypiMWtfj8o65/hf_20260314_193703_1689978b-9a6b-4fd2-b1c0-135c5163fd56.jpg';
export function HeroSection() {
  return <section className="pt-14 pb-6 md:pt-28 md:pb-20 px-4 bg-white overflow-hidden" data-id="element-127">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center space-y-3 md:space-y-6" data-id="element-128">
        <div className="inline-flex items-center space-x-1 text-caramel-dark font-bold text-sm md:text-base mb-1" data-id="element-129">
          <div className="flex" data-id="element-130">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-caramel text-caramel" data-id="element-131" />)}
          </div>
          <span className="ml-2 text-brown-dark opacity-80" data-id="element-132">
            Más de <strong className="text-[110%]" data-id="element-133">2.137</strong> alumnas
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brown-dark leading-tight" data-id="element-134">
          Gana{' '}
          <span className="text-caramel-dark" data-id="element-135">
            <strong className="text-[110%]" data-id="element-136">$400</strong> extra al mes
          </span>{' '}
          vendiendo flanes desde casa
        </h1>
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-brown-dark/80 leading-snug -mt-1 md:-mt-2" data-id="element-137">
          — sin horno, sin experiencia y empezando este fin de semana.
        </p>

        {/* Hero Image */}
        <div className="w-full max-w-xl mx-auto" data-id="element-138">
          <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-139">
            <img src={HERO_IMAGE} alt="Flan casero con caramelo — Flanes Sin Horno" className="w-full h-auto object-cover" width={600} height={400} fetchPriority="high" data-id="element-140" />
          </div>
        </div>

        <div className="flex flex-col items-center w-full" data-id="element-141">
          <a href="#pricing-cta" className="w-full md:w-auto block text-center bg-cta-green hover:bg-green-700 text-white font-heading font-bold md:text-2xl min-h-[52px] py-3.5 px-8 rounded-xl shadow-lg animate-pulse-glow transition-all transform hover:scale-105 text-[20px]" data-id="element-142">
            QUIERO MI RECETARIO »
          </a>
          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 mt-2.5 md:mt-4 text-xs md:text-sm text-gray-600 font-medium" data-id="element-143">
            <span className="flex items-center" data-id="element-144">
              <CheckCircleIcon className="w-3.5 h-3.5 mr-1 text-success-green" data-id="element-145" />{' '}
              Acceso inmediato por email
            </span>
            <span className="flex items-center" data-id="element-146">
              <CheckCircleIcon className="w-3.5 h-3.5 mr-1 text-success-green" data-id="element-147" />{' '}
              Pago único
            </span>
          </div>
        </div>
      </div>
    </section>;
}